import { CohortEnumSchema } from '@eigtech/auth0-types';
import { z } from 'zod';
import { DocumentSchemaV2 } from '../aggregates/index.js';
export const AddDocumentFromS3ApiSchema = {
    body: DocumentSchemaV2.pick({
        createdBy: true,
        entityId: true,
        externalSystemId: true,
        filename: true,
        metaData: true,
        notes: true,
        parentFilename: true,
        source: true,
        type: true,
        title: true
    }).extend({
        description: z.string().optional(),
        bucketName: z.string(),
        key: z.string(),
        userCohorts: CohortEnumSchema.array().optional(),
    }),
    response: DocumentSchemaV2,
};
export const AddDocumentFromS3RequestSchema = AddDocumentFromS3ApiSchema.body;
export const AddDocumentFromS3ResponseSchema = AddDocumentFromS3ApiSchema.response;
